import { render, staticRenderFns } from "./DashboardCookingHealthList.vue?vue&type=template&id=2fe7c7a7&"
import script from "./DashboardCookingHealthList.vue?vue&type=script&lang=js&"
export * from "./DashboardCookingHealthList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports